export const titleToId = (title) => {
  return title
    .toLowerCase()
    .replace(/\(.*\)/g, "")
    .trim()
    .replace(/ /g, "-");
};
